import { authFetch } from './authFetch';
import { getAuthToken } from './authHelpers';

export async function toggleFavorite({ creatorProfileId, propertyId }) {
  const token = getAuthToken();
  if (!token) return null;

  const base = window.location.hostname === 'localhost' ? 'http://localhost:4000' : '';
  const payload = creatorProfileId
    ? { creator_profile_id: creatorProfileId }
    : { property_id: propertyId };

  try {
    const res = await authFetch(`${base}/api/favorites/toggle`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }, { requireAuth: true });

    const data = await res.json();
    if (res.ok && data.ok) {
      return data.favorited;
    }
    return null;
  } catch (err) {
    if (!err.message?.includes('Unauthorized') && !err.message?.includes('expired')) {
      console.error('Favorite toggle error:', err);
    }
    return null;
  }
}
